import React from 'react';
import PropTypes from 'prop-types';

import {Stack, Typography, Button} from 'views/components';
import {ArrowDownward, ArrowUpward} from 'views/icons';
import {Translate} from 'views/module';

import SelectCorrespondanceType from './SelectCorrespondanceType';

{/* Header for the Correspondance. Includes the title, which correspondance user wants to view and order */}
const NewMessageHeader = (props) => {
  const {
    sortDir,
    setSortDir,
    corType,
    setCorType,
  } = props;

  const sortDesc = 'DESC';
  const sortAsc = 'ASC';

  const onSortClick = () => {
    const invertSortDir = sortDir === sortDesc ? sortAsc : sortDesc;
    setSortDir(invertSortDir);
  };

  return (
    <Stack
      direction="row"
      alignItems="flex-start"
      justifyContent="space-between"
      spacing={1}
      sx={{
        minWidth: 0,
      }}
    >
      <Stack
        sx={{
          minWidth: 0,
          flex: 1,
        }}
      >
        <SelectCorrespondanceType
          corType={corType}
          setCorType={setCorType}
        />
      </Stack>
      <Stack
        sx={{
          flexShrink: 0,
        }}
      >
        <Button
          variant="text"
          endIcon={sortDir === sortDesc ? <ArrowDownward /> : <ArrowUpward />}
          onClick={onSortClick}
          sx={{
            'textTransform': 'none',
            'fontWeight': 500,
            'color': '#484442',
            '&:hover': {
              backgroundColor: 'rgba(118, 118, 118, 0.1)',
            },
            'borderRadius': '8px',
            'py': 0.5,
            'px': 1,
          }}
        >
          <Typography
            variant="subtitle2"
            sx={{fontWeight: 500, fontSize: '12px'}}
          >
            {
              sortDir === sortDesc &&
              <Translate expression='caregiver.CaregiverDetail.Correspondance.Sort.NewestFirst'/>
            }
            {
              sortDir === sortAsc &&
              <Translate expression='caregiver.CaregiverDetail.Correspondance.Sort.OldestFirst'/>
            }
          </Typography>
        </Button>
      </Stack>
    </Stack>
  );
};
NewMessageHeader.propTypes = {
  corType: PropTypes.shape({
    ANNOUNCEMENTS: PropTypes.bool.isRequired,
    COMMENTS: PropTypes.bool.isRequired,
    LOGS: PropTypes.bool.isRequired,
    EMAIL: PropTypes.bool.isRequired,
  }).isRequired,
  setCorType: PropTypes.func.isRequired,
  sortDir: PropTypes.string.isRequired,
  setSortDir: PropTypes.func.isRequired,
};

export default React.memo(NewMessageHeader);
